import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenCleanupService {
  removeTokenFromHistory(): boolean {
    const url = new URL(window.location.href);
    const pathSegments = url.pathname.split('/').filter((s) => s.length > 0);
    const rawLast = pathSegments[pathSegments.length - 1];
    if (!rawLast) {
      return false;
    }
    const lastSegment = this.stripQueryAndHashFromSegment(rawLast);
    if (!this.isJWTFormat(lastSegment)) {
      return false;
    }
    this.replaceHistoryWithParentPath(url, pathSegments);
    return true;
  }

  private isJWTFormat(tokenCandidate: string): boolean {
    const parts = tokenCandidate.split('.');
    return parts.length === 3;
  }

  private stripQueryAndHashFromSegment(segment: string): string {
    return segment.split('?')[0]?.split('#')[0] ?? '';
  }

  private replaceHistoryWithParentPath(url: URL, pathSegments: string[]): void {
    const parentPathname =
      pathSegments.length <= 1 ? '/' : `/${pathSegments.slice(0, -1).join('/')}`;
    const newUrl = `${parentPathname}${url.search}${url.hash}`;
    window.history.replaceState({}, '', newUrl);
  }
}
